import { FunctionComponent } from 'react';

// Components
import Image from '@Components/Utils/Image';
import Anchor from '@Components/Utils/Anchor';
import AvatarStar from '@Components/UI/AvatarStar';

// Styles
import styles from './DoctorItem.module.scss';

// Utilities
import classnames from 'classnames';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';


interface DoctorItemProps {
    id?: string;
    title?: string;
    avatar?: string;
    fullName?: string;
    className?: string;
    experience?: number;
    rating?: {
        count: number;
        average: number;
    };
    specialist?: Array<string>;
}

const DoctorItem: FunctionComponent<DoctorItemProps> = (props) => {
    const { deviceType } = useViewDetected();

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        props.className,
    ]);

    return (
        <Anchor href={`/tra-cuu/bac-si/${props.id}`} className={className}>
            <div className={styles.avatar_left}>
                <AvatarStar avatar={props.avatar} average={props?.rating?.average} className={styles.avatar_wrapper} />
            </div>

            <div className={styles.summary}>
                <div className={styles.name}>BS. {props.fullName}</div>
                <div className={styles.title}>
                    <Image className={styles.medal} src={'/assets/tra-cuu/bac-si/medal_icon.png'} />
                    {props?.title}
                </div>

                {props?.specialist && <div className={styles.info}>{props?.specialist?.join(', ')}</div>}
                <div className={styles.experience}>{props.experience || 'Chưa rõ'} năm kinh nghiệm </div>
            </div>
        </Anchor>
    );
};

DoctorItem.defaultProps = {
    id: '',
    title: '',
    avatar: '',
    fullName: '',
    className: '',
    experience: 0,
    specialist: [],
    rating: {
        count: 0,
        average: 0,
    },
};

export default DoctorItem;
